import {
  CheckCircledIcon,
  CrossCircledIcon,
  UpdateIcon,
} from '@radix-ui/react-icons';
import { Flex, Text } from '@radix-ui/themes';
import { PitchListHelper } from 'classes/helpers/pitch-list.helper';
import { CustomIcon } from 'components/common/custom-icon';
import { CustomIconPath } from 'enums/custom.enums';
import { ITrainedStatusConfig } from 'interfaces/i-training';
import { StringHelper } from 'lib_ts/classes/string.helper';
import { TrainedStatus } from 'lib_ts/enums/pitch-list.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useMemo } from 'react';

const TrainedStatusIcon = (props: {
  mode: TrainedStatus;
  className?: string;
}) => {
  switch (props.mode) {
    case TrainedStatus.Precision: {
      return (
        <Text color={RADIX.COLOR.SUCCESS} className={props.className}>
          <CustomIcon icon={CustomIconPath.CheckCircledFilled} />
        </Text>
      );
    }

    case TrainedStatus.Trained: {
      return (
        <Text color={RADIX.COLOR.SUCCESS} className={props.className}>
          <CheckCircledIcon />
        </Text>
      );
    }

    case TrainedStatus.Untrained:
    default: {
      return (
        <Text color={RADIX.COLOR.NEUTRAL} className={props.className}>
          <CrossCircledIcon />
        </Text>
      );
    }
  }
};

export const CommonTrainingStatusIcon = (
  props: ITrainedStatusConfig & {
    // if false, then an update icon will be shown if the pitch can be refreshed
    autoRefresh: boolean;
    canRefresh: boolean;
  }
) => {
  const status = useMemo(
    () =>
      PitchListHelper.getTrainedStatus({
        tms: props.tms,
        last_hardware_changed: props.last_hardware_changed,
      }),
    [props.tms, props.last_hardware_changed]
  );

  const showUpdateIcon = !props.autoRefresh && props.canRefresh;

  return (
    <Flex data-testid="ShotSummary" align="center" justify="center">
      <UpdateIcon className={!showUpdateIcon ? 'hidden' : ''} />
      <TrainedStatusIcon
        mode={status}
        className={StringHelper.classNames([
          'flex-row',
          showUpdateIcon ? 'hidden' : '',
        ])}
      />
    </Flex>
  );
};
